import { AssertionError } from "assert";
import {
  JsonConverter,
  JsonCustomConvert,
  JsonObject
} from "json2typescript";

import { PreferenceKey } from "./preference-key.enum";

@JsonObject
export class Preferences {

  private _data: any;

  constructor(data: any = {}) {
    try {
      this._data = JSON.parse(data);
    } catch (e) {
      this._data = data;
    }
  }

  public serialize(): any {
    return this._data || {};
  }

  public preference(key: PreferenceKey, throwOnMissing: boolean = true, defaultValueIfMissing: any = null): any {
    if (null != this._data && key in this._data) {
      return this._data[key];
    } else {
      if (throwOnMissing) {
        throw new AssertionError(
          {
            message: `Key '${key}' was not present in the Preferences.`,
            expected: "A value",
            actual: "No value"
          }
        );
      } else {
        return defaultValueIfMissing;
      }
    }
  }

}

// tslint:disable-next-line: max-classes-per-file
@JsonConverter
export class PreferencesConverter implements JsonCustomConvert<Preferences> {
  public serialize(data: Preferences): any {
    return data ? data.serialize() : null;
  }

  public deserialize(val: any): Preferences {
    if (null == val) {
      return null;
    }
    return new Preferences(val);
  }
}
